(function () {
  'use strict';

  /* ---------- newsletter popup ---------- */

  function initNewsletterPopup() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;

    var closeBtn = popup.querySelector('[data-newsletter-close]');
    var justSubmitted = popup.querySelector('.newsletter-popup__success');

    if (justSubmitted) {
      popup.hidden = false;
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.hidden = true;
      });
    }

    document.querySelectorAll('[data-newsletter-open]').forEach(function (opener) {
      opener.addEventListener('click', function (event) {
        event.preventDefault();
        popup.hidden = false;
      });
    });

    var form = popup.querySelector('[data-klaviyo-form]');
    var emailInput = popup.querySelector('[data-klaviyo-email]');
    if (form && emailInput) {
      var publicKey = popup.getAttribute('data-klaviyo-public-key');
      var listId = popup.getAttribute('data-klaviyo-list-id');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var email = emailInput.value;

        subscribeToShopify(form);

        if (publicKey && listId) {
          subscribeToKlaviyo(publicKey, listId, email)
            .then(showSubscribeSuccess)
            .catch(showSubscribeError);
        } else {
          showSubscribeSuccess();
        }
      });
    }

    function showSubscribeSuccess() {
      form.innerHTML = '<p class="newsletter-popup__success">subscribed &#10003;</p>';
    }

    function showSubscribeError() {
      form.innerHTML = '<p class="newsletter-popup__success">something went wrong, please try again</p>';
    }
  }

  function subscribeToShopify(form) {
    fetch('/contact', {
      method: 'POST',
      body: new FormData(form),
    }).catch(function () {});
  }

  function subscribeToKlaviyo(publicKey, listId, email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2026-07-15',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email },
              },
            },
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId },
            },
          },
        },
      }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Klaviyo subscribe failed: ' + response.status);
      }
    });
  }

  /* ---------- product page: variant picker + gallery ---------- */

  function initProductForms() {
    var sections = document.querySelectorAll('[data-product-section]');
    sections.forEach(initProductSection);
  }

  function initProductSection(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-product-price]');
    var buyButton = section.querySelector('[data-add-to-cart]');
    var optionGroups = section.querySelectorAll('.product__option');
    var mainImages = section.querySelectorAll('[data-main-image]');
    var thumbs = section.querySelectorAll('[data-thumb]');

    var selected = [];
    optionGroups.forEach(function (group) {
      var current = group.querySelector('.option-button.is-selected');
      var position = parseInt(group.getAttribute('data-option-position'), 10);
      selected[position - 1] = current ? current.getAttribute('data-option-value') : null;
    });

    function findVariant(options) {
      return product.variants.filter(function (variant) {
        return ['option1', 'option2', 'option3'].every(function (key, index) {
          return options[index] == null || variant[key] === options[index];
        });
      })[0];
    }

    function refresh() {
      var variant = findVariant(selected);

      optionGroups.forEach(function (group) {
        var position = parseInt(group.getAttribute('data-option-position'), 10);
        group.querySelectorAll('.option-button').forEach(function (button) {
          var value = button.getAttribute('data-option-value');
          button.classList.toggle('is-selected', selected[position - 1] === value);

          var trialOptions = selected.slice();
          trialOptions[position - 1] = value;
          var trialVariant = findVariant(trialOptions);
          button.classList.toggle('is-unavailable', !trialVariant || !trialVariant.available);
        });
      });

      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) {
        var html = '';
        if (variant.compare_at_price > variant.price) {
          html += '<s>' + formatMoney(variant.compare_at_price) + '</s>';
        }
        html += formatMoney(variant.price);
        priceEl.innerHTML = html;
      }

      if (buyButton) {
        buyButton.disabled = !variant.available;
        buyButton.textContent = variant.available ? 'add to cart' : 'sold out';
      }

      if (mainImages.length && variant.featured_image) {
        mainImages.forEach(function (img) {
          img.src = variant.featured_image.src;
        });
      }
    }

    optionGroups.forEach(function (group) {
      var position = parseInt(group.getAttribute('data-option-position'), 10);
      group.querySelectorAll('.option-button').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.classList.contains('is-unavailable')) return;
          selected[position - 1] = button.getAttribute('data-option-value');
          refresh();
        });
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('is-selected');
        });
        thumb.classList.add('is-selected');
        var src = thumb.getAttribute('data-full-src');
        mainImages.forEach(function (img) {
          img.src = src;
        });
      });
    });

    var form = section.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart(form);
      });
    }

    refresh();
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'GBP',
    });
  }

  /* ---------- ajax add to cart ---------- */

  function addToCart(form) {
    var formData = new FormData(form);
    var buyButton = form.querySelector('[data-add-to-cart]');
    if (buyButton) buyButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateCartThumbs(cart.items);
        showItemAdded();
      })
      .catch(function () {})
      .finally(function () {
        if (buyButton) buyButton.disabled = false;
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function updateCartThumbs(items) {
    document.querySelectorAll('[data-cart-thumbs]').forEach(function (container) {
      container.innerHTML = '';
      items.forEach(function (item) {
        var link = document.createElement('a');
        link.className = 'site-header__cart-thumb';
        link.href = '/cart';

        var img = document.createElement('img');
        img.src = item.image;
        img.width = 56;
        img.alt = '';

        link.appendChild(img);
        container.appendChild(link);
      });
    });
  }

  function showItemAdded() {
    var indicator = document.querySelector('[data-item-added]');
    if (!indicator) return;

    indicator.hidden = false;
    window.clearTimeout(indicator._hideTimeout);
    indicator._hideTimeout = window.setTimeout(function () {
      indicator.hidden = true;
    }, 4000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNewsletterPopup();
    initProductForms();
  });
})();
